module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_red_10-53e64bd96ad5c25f41e542f156b9faae.svg";